import type { GameLike } from '@sportninja/common/features/game/gameListView/types'

/**
 * The competition the edit modal should seed its option lists from.
 *
 * The modal fetches teams (`/schedules/:id/teams/simple`), venues and
 * sub-competitions off ONE id, and every other entry point hands it the ROOT
 * competition: the Add Game button passes the URL's `SCHEDULE_ID`, the Game
 * page passes `game.rootSchedule.id`, the legacy form passes
 * `values.rootSchedule?.id`.
 *
 * A grid row's `schedule` is the DIVISION ("Division 7 19+"), not the root, so
 * preferring it scoped the modal to a sub-schedule and returned the wrong team
 * pool (SN-8244). The host's own id — already the root on the competition page
 * — wins; the row is only the fallback for the Team / My Schedule hosts, which
 * pass none of their own when "All Seasons" is selected.
 */
export const resolveEditModalScheduleId = (
  hostScheduleId: string | null | undefined,
  game: GameLike | null | undefined
): string | null => hostScheduleId || game?.schedule?.id || null
